import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
export function HistoryTab({ history, theme, t, onOpen, onRename, onDelete }) {
    const [editingId, setEditingId] = useState(null);
    const [draft, setDraft] = useState("");
    const [confirmingId, setConfirmingId] = useState(null);
    const [hoveredId, setHoveredId] = useState(null);
    const text = theme.primaryTextColor || theme.contentColor || theme.foreground;
    const muted = theme.secondaryTextColor || "#64748b";
    const cardBg = theme.cardBackgroundColor || theme.secondaryBackground || "#ffffff";
    const border = "1px solid #d8e0eb";
    const sectionBg = theme.background || "#f4f7fb";
    const gradientBase = theme.homepageGradientBaseColor || "#d9e1ec";
    const buttonBg = "#1f2937";
    const inputBg = "#eef3f9";
    return (_jsxs("div", { style: {
            padding: "0 10px",
            display: "grid",
            gap: 0,
            alignContent: "start",
            gridAutoRows: "max-content",
            position: "relative",
            background: sectionBg,
            height: "100%",
            maxHeight: "100%",
            overflowY: "auto",
        }, children: [_jsx("div", { "aria-hidden": true, style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "70%",
                    background: `linear-gradient(180deg, ${gradientBase} 0%, ${sectionBg} 100%)`,
                    pointerEvents: "none",
                    zIndex: 0,
                } }), history.map((item) => {
                const isEditing = editingId === item.id;
                const isHovered = hoveredId === item.id;
                const isFirst = item === history[0];
                const isLast = item === history[history.length - 1];
                return (_jsxs("div", { onClick: () => onOpen(item), onMouseEnter: () => setHoveredId(item.id), onMouseLeave: () => setHoveredId(null), style: {
                        borderTop: isFirst ? border : "none",
                        borderBottom: border,
                        padding: "12px 4px 12px 14px",
                        marginTop: isFirst ? 30 : 0,
                        background: cardBg,
                        cursor: "pointer",
                        display: "grid",
                        gap: 6,
                        height: "auto",
                        overflow: "hidden",
                        position: "relative",
                        zIndex: 1,
                        borderTopLeftRadius: isFirst ? 14 : 0,
                        borderTopRightRadius: isFirst ? 14 : 0,
                        borderBottomLeftRadius: isLast ? 14 : 0,
                        borderBottomRightRadius: isLast ? 14 : 0,
                        transform: isHovered ? "translateY(-1px)" : "translateY(0)",
                        boxShadow: isHovered ? "0 10px 20px rgba(15,23,42,0.10)" : "none",
                        transition: "transform 0.16s ease, box-shadow 0.16s ease",
                    }, children: [_jsxs("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }, children: [_jsxs("div", { style: { display: "grid", gap: 6, flex: 1, minWidth: 0 }, children: [isEditing ? (_jsx("input", { value: draft, onChange: (e) => setDraft(e.target.value), onKeyDown: (e) => {
                                                if (e.key === "Enter") {
                                                    onRename(item.id, draft.trim() || item.title);
                                                    setEditingId(null);
                                                }
                                            }, autoFocus: true, style: {
                                                width: "100%",
                                                padding: "8px 10px",
                                                borderRadius: 10,
                                                border,
                                                background: inputBg,
                                                color: text,
                                            }, onClick: (e) => e.stopPropagation() })) : (_jsx("div", { style: { fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, children: item.title })), _jsx("div", { style: { fontSize: 12, color: muted }, children: item.timestamp })] }), _jsxs("div", { style: { display: "flex", alignItems: "center", gap: 10, flexShrink: 0, marginRight: 0 }, children: [_jsx("button", { "aria-label": t("history.rename"), onClick: (e) => {
                                                e.stopPropagation();
                                                if (isEditing) {
                                                    onRename(item.id, draft.trim() || item.title);
                                                    setEditingId(null);
                                                    return;
                                                }
                                                setEditingId(item.id);
                                                setDraft(item.title);
                                            }, style: {
                                                border: "none",
                                                background: "transparent",
                                                color: "#334155",
                                                cursor: "pointer",
                                                padding: 0,
                                                lineHeight: 1,
                                            }, children: _jsxs("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", "aria-hidden": true, children: [_jsx("path", { d: "M4 20h4l10-10-4-4L4 16v4z", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M12 6l4 4", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" })] }) }), _jsx("button", { "aria-label": t("history.delete"), onClick: (e) => {
                                                e.stopPropagation();
                                                setConfirmingId(item.id);
                                            }, style: {
                                                border: "none",
                                                background: "transparent",
                                                color: "#f87171",
                                                cursor: "pointer",
                                                padding: 0,
                                                lineHeight: 1,
                                            }, children: _jsx("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", "aria-hidden": true, children: _jsx("path", { d: "M6 6l12 12M18 6L6 18", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round" }) }) })] })] }), _jsx("div", { style: {
                                fontSize: 13,
                                color: muted,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }, children: item.excerpt })] }, item.id));
            }), confirmingId && (_jsx("div", { onClick: () => setConfirmingId(null), style: {
                    position: "absolute",
                    inset: 0,
                    background: "#e2e8f0",
                    display: "grid",
                    placeItems: "center",
                    padding: 12,
                    zIndex: 5,
                }, children: _jsxs("div", { onClick: (e) => e.stopPropagation(), style: {
                        background: cardBg,
                        border,
                        borderRadius: 14,
                        padding: 16,
                        width: "100%",
                        maxWidth: 320,
                        display: "grid",
                        gap: 10,
                        color: text,
                    }, children: [_jsx("div", { style: { fontWeight: 700, fontSize: 16 }, children: t("history.deleteTitle") }), _jsx("div", { style: { fontSize: 13, color: muted }, children: t("history.deleteBody") }), _jsxs("div", { style: { display: "flex", justifyContent: "flex-end", gap: 8 }, children: [_jsx("button", { onClick: () => setConfirmingId(null), style: {
                                        padding: "8px 12px",
                                        borderRadius: 10,
                                        border,
                                        background: buttonBg,
                                        color: "#ffffff",
                                        cursor: "pointer",
                                    }, children: t("history.cancel") }), _jsx("button", { onClick: () => {
                                        if (!confirmingId)
                                            return;
                                        onDelete(confirmingId);
                                        setConfirmingId(null);
                                    }, style: {
                                        padding: "8px 12px",
                                        borderRadius: 10,
                                        border: "1px solid #ef4444",
                                        background: "#3f1f25",
                                        color: "#fecaca",
                                        cursor: "pointer",
                                    }, children: t("history.confirmDelete") })] })] }) }))] }));
}
